import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { useData } from '../../contexts/DataContext';
import { useMediaQuery } from 'react-responsive';
import ProjectDetailDesktop from '../../components/Desktop/ProjectDetailDesktop';
import ProjectDetailMobile from '../../components/Mobile/ProjectDetailMobile';

const ProjectDetail = () => {
  const { t } = useTranslation();
  const { slug } = useParams();
  const { language, updateDocumentTitle } = useLanguage();
  const result = useData();
  const isMobile = useMediaQuery({ minWidth: 0, maxWidth: 768 });

  const findProjectBySlug = (projects, targetSlug) => {
    if (!projects) return null;
    return Object.values(projects).find(project => project.slug === targetSlug);
  };

  const project = findProjectBySlug(result.data?.projects, slug) || {};

  const sharedProps = {
    project,
    language,
    siteInfo: result.data?.site_info
  };

  useEffect(() => {
    if (result.data.site_info) {
      updateDocumentTitle(project.title, result.data?.site_info);
    }
  }, [result, t, language, updateDocumentTitle]);

  if (!project?.slug) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-12 h-12 rounded-full border-t-2 border-b-2 animate-spin border-stone-800"></div>
      </div>
    );
  }

  return isMobile ? (
    <ProjectDetailMobile {...sharedProps} />
  ) : (
    <ProjectDetailDesktop {...sharedProps} />
  );
};

export default ProjectDetail;